module.exports = __webpack_public_path__ + "img/AGRALE.9f2ce920.svg";